import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentCont, ContentNote, ContentQuestion } from './ConfirmSurveyQuitModal.styles';
import Modal from '../../HOC/Modal/Modal';

interface IConfirmSurveyQuitModal {
  active: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title?: string;
  note?: string;
  question?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

export const ConfirmSurveyQuitModal: FC<IConfirmSurveyQuitModal> = ({
  active,
  onConfirm,
  onClose,
  title,
  note,
  question,
  cancelLabel,
  confirmLabel,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      active={active}
      title={title ?? t('viewSurvey.contents.modals.quit.title')}
      width="480px"
      buttonNames={{
        action: confirmLabel ?? t('viewSurvey.contents.modals.quit.actions.confirm'),
        cancel: cancelLabel ?? t('viewSurvey.contents.modals.quit.actions.cancel'),
      }}
      callToAction={onConfirm}
      closeModal={onClose}
      top='150px'
    >
      <ContentCont>
        <ContentNote>{note ?? t('viewSurvey.contents.modals.quit.note')}</ContentNote>
        <ContentQuestion>{question ?? t('viewSurvey.contents.modals.quit.question')}</ContentQuestion>
      </ContentCont>
    </Modal>
  );
};
